import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '@/axiosInstance'; 

export const fetchVideos = createAsyncThunk(
    'watchAndBuy/fetchVideos', 
    async (_, {rejectWithValue}) => {
        try {
            const response = await axiosInstance.get('/api/website/videos');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Something went wrong');
        }
    }
)


const watchAndBuySlice = createSlice(
    {
        name: 'watchAndBuy',
        initialState:{
            videos: [],
            loading: false,
            error: null,
        },
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(fetchVideos.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(fetchVideos.fulfilled, (state, action) => {
                    state.loading = false;
                    state.videos = action.payload;
                })
                .addCase(fetchVideos.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                })
            }
    }
)

export default watchAndBuySlice.reducer;